const CSV_SPECIAL_CHARACTERS = /[",\r\n]/

export type CsvValue = string | number | boolean | undefined

export function escapeCsvField(value: string): string {
  if (!CSV_SPECIAL_CHARACTERS.test(value)) return value
  return `"${value.replace(/"/g, '""')}"`
}

export function toCsvRow(values: readonly CsvValue[]): string {
  return values.map((value) => escapeCsvField(String(value ?? ''))).join(',')
}

export function joinCsvRows(rows: readonly string[]): string {
  return rows.join('\r\n')
}
